import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Role} from '../models/role';
import {User} from '../models/user';
import {UserService} from '../services/user.service';
import {LocationRoute} from "../models/locationconfig";
import {Gateway} from "../models/gateway";
import {KnownRoutes} from "../models/known-routes";

@Component({
  selector: 'app-routes-dialog',
  templateUrl: './routes-dialog.component.html',
  styleUrls: ['./routes-dialog.component.sass'],
  standalone: false
})
export class RoutesDialogComponent implements OnInit {
  gateways = Object.values(Gateway);
  knownRoutes = Object.values(KnownRoutes);
  user: User;
  locationRoute: LocationRoute;

  constructor(
      private dialogRef: MatDialogRef<RoutesDialogComponent>,
      private userService: UserService,
      @Inject(MAT_DIALOG_DATA) route:LocationRoute,
  ) {
    this.userService.getUserRole().then((user) => {
      this.user = user;
    });

    if (!route) {
      this.locationRoute = new LocationRoute();
    } else {
      this.locationRoute = Object.assign({}, route);
    }
  }

  ngOnInit() {
  }

  save() {
    this.dialogRef.close(this.locationRoute);
  }

  close() {
    this.dialogRef.close();
  }

  isEnabled(value: string): boolean {
    switch (this.user?.Role) {
      case Role.Admin:
      case Role.Maintainer:
        return true;
      default:
        return false;
    }
  }
}
